module.exports = __webpack_public_path__ + "img/business-startup.705d9776.png";